<app-data-table mainTitle="Mov Balancte"
            singleTitle="Balancete"
            routerPath="/mov-balancete"
            entityPath="/movbalancete"
            keyField="id"
            [entity]="movBalancete"
            [columns]="this['columns']"
            [controls]="this['controls']">
</app-data-table>